/**
 * Keeps the plain-language promotion summary in sync
 * with the buy / pay quantity inputs, so an admin
 * reads "Customers buy 3 and pay for 2. The cheapest
 * one is free." instead of decoding two bare numbers.
 *
 * The sentence templates are rendered server-side and
 * passed in as values, so the copy stays translatable
 * and the initial paint is already correct without JS.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["buy", "pay", "output"];
  static values = {
    singular: String,
    plural: String,
    placeholder: String,
  };

  connect() {
    this.render();
  }

  render() {
    const buy = parseInt(this.buyTarget.value, 10);
    const pay = parseInt(this.payTarget.value, 10);
    const free = buy - pay;

    if (!Number.isInteger(buy) || !Number.isInteger(pay)) {
      this.outputTarget.textContent = this.placeholderValue;
      return;
    }

    if (pay < 1 || free < 1) {
      this.outputTarget.textContent = this.placeholderValue;
      return;
    }

    const template = free === 1 ? this.singularValue : this.pluralValue;

    this.outputTarget.textContent = template
      .replaceAll("%{buy}", buy)
      .replaceAll("%{pay}", pay)
      .replaceAll("%{free}", free);
  }
}
